// AddTermsAndConditions.jsx  ← missing tha, ab add kiya
import React, { useState, useRef } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import JoditEditor from 'jodit-react';
import 'react-toastify/dist/ReactToastify.css';

const BASE_URL = 'https://api.sofiasurgicals.com/api';

const joditConfig = {
  readonly: false,
  height: 450,
  placeholder: 'Write Terms & Conditions content here...',
  buttons: [
    'bold', 'italic', 'underline', '|',
    'ul', 'ol', '|',
    'h1', 'h2', 'h3', '|',
    'blockquote', 'link', '|',
    'undo', 'redo',
  ],
};

const AddTermsAndConditions = () => {
  const navigate = useNavigate();
  const editorRef = useRef(null);

  const [content, setContent] = useState('');
  const [status, setStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Read from ref for latest value
    const currentContent = editorRef.current?.value || content;

    if (!currentContent || currentContent.replace(/<[^>]+>/g, '').trim().length < 10) {
      toast.error('Terms & Conditions content is required');
      return;
    }

    setIsLoading(true);
    try {
      await axios.post(`${BASE_URL}/add-TermsAndCondition`, {
        TermsAndCondition: currentContent, // ✅ correct field name
        status,
      });
      toast.success('Terms & Conditions created successfully!');
      setTimeout(() => navigate('/all-TermsAndCondition'), 1500);
    } catch (error) {
      const msg = error.response?.data?.message || 'Failed to create Terms & Conditions';
      // ✅ If already exists — redirect to edit
      if (error.response?.status === 400 && error.response?.data?.existingId) {
        toast.warning('Already exists. Redirecting to edit...');
        setTimeout(() => navigate(`/edit-TermsAndCondition/${error.response.data.existingId}`), 1500);
      } else {
        toast.error(msg);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="bread d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0">Add Terms &amp; Conditions</h4>
      </div>

      <form className="row g-3" onSubmit={handleSubmit}>
        <div className="col-md-12">
          <label className="form-label fw-semibold">
            Content <span className="text-danger">*</span>
          </label>
          <JoditEditor
            ref={editorRef}
            value={content}
            config={joditConfig}
            onBlur={(val) => setContent(val)} // ✅ onBlur — avoids re-render on each keystroke
          />
        </div>

        <div className="col-md-12">
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="statusCheck"
              checked={status}
              onChange={(e) => setStatus(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="statusCheck">
              Active (visible on website)
            </label>
          </div>
        </div>

        <div className="col-12 text-center">
          <button
            type="submit"
            className="btn btn-primary px-5"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Saving...
              </>
            ) : (
              'Publish Terms & Conditions'
            )}
          </button>
        </div>
      </form>
    </>
  );
};

export default AddTermsAndConditions;